// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#myServices #services{font-weight:900;font-size:3rem;text-transform:uppercase}@media (min-width:720px){#myServices #services{font-size:3.5rem}}#myServices .service{border-radius:5px;margin:5px;padding-top:10px}#myServices .service .img{width:4rem}", ""]);
// Exports
module.exports = exports;
